(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EvaluationToken', EvaluationToken);

    EvaluationToken.$inject = ['$resource'];

    function EvaluationToken ($resource) {
        var resourceUrl =  'api/evaluation-tokens/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
